<template>
  <section class="r-world-region-territory-page">
    <ac-data-table
      ref="table"
      :headers="headers"
      :items="items"
      :item-class="row_class"
      hide-default-footer
      disable-pagination
      sort-by="regionTerritory"
      item-key="uid"
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="World Region Territories"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Region Territory
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-world-region-territory-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </section>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {WorldRegionTerritory} from "@/modules/redactor/models/world-region/WorldRegionTerritory";
import RWorldRegionTerritoryDialog from "@/modules/redactor/views/world-region-territory/r-world-region-territory-dialog";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";

export default {
  name: "r-world-region-territory-page",
  components: {RDialogPreviewCollection, AcDataTable, RWorldRegionTerritoryDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Region Territory", value: "regionTerritory"},
      {text: "UID", value: "uid"},
      {text: "Key", value: "key"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(WorldRegionTerritory)
    },
    selected: [],
    bulkMode: false,
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    getNextRegionTerritoryId() {
      const allRegions = RedactorUtils.getWorldRegionTerritories();
      const usedIds = allRegions
        .map(item => item.regionTerritory)
        .filter(id => Number.isInteger(id) && id > 0)
        .sort((a, b) => a - b);
      
      if (usedIds.length === 0) {
        return 1;
      }
      
      // Find the first missing number in the sequence starting from 1
      for (let i = 1; i <= usedIds[usedIds.length - 1]; i++) {
        if (!usedIds.includes(i)) {
          return i;
        }
      }
      
      // If no gaps found, return the next number after the highest
      return usedIds[usedIds.length - 1] + 1;
    },
    isUnique(item, allItems) {
      if (!allItems || !Array.isArray(allItems) || !item) {
        return true;
      }
      
      const duplicates = allItems.filter(otherItem => 
        otherItem.uid !== item.uid && 
        otherItem.regionTerritory === item.regionTerritory
      );
      
      return duplicates.length === 0;
    },
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_copy(item) {
      const copiedItem = item.copy();
      copiedItem.regionTerritory = this.getNextRegionTerritoryId();
      this.$refs['dialog'].show(ViewRules.COPY, copiedItem).then(
          result => {
            RedactorUtils.pushWorldRegionTerritory(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_create() {
      const newItem = new WorldRegionTerritory();
      newItem.regionTerritory = this.getNextRegionTerritoryId();
      this.$refs['dialog'].show(ViewRules.CREATE, newItem).then(
          result => {
            RedactorUtils.pushWorldRegionTerritory(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            RedactorUtils.pushWorldRegionTerritory(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeWorldRegionTerritory(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkWorldRegionTerritories(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushWorldRegionTerritory(result);
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, WorldRegionTerritory, "world-region-territory")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getWorldRegionTerritories();
  }
}
</script>